<template>
    <TableFilter :filter-refs="$refs"
                 @apply-filter="applyFilter"
    >
        <div class="filter_item filter_item_xxl">
            <TextFilter :label-text="$t('common.debtor')"
                        columnName="debtorName"
                        ref="filter_debtorName"
            ></TextFilter>
            <TextFilter :label-text="$t('common.investor')"
                        columnName="buyerName"
                        ref="filter_buyerName"
            ></TextFilter>
            <EnumFilter :label-text="$t('common.type')"
                        columnName="receivableType"
                        :enum-def="enumDef.receivableType"
                        ref="filter_receivableType"
            ></EnumFilter>
            <TextFilter :label-text="$t('common.invoiceNumber')"
                        columnName="invoiceNumber"
                        ref="filter_invoiceNumber"
            ></TextFilter>
            <DateFilter :label-text="$t('common.dueDate')"
                        column-name="dueDate"
                        ref="filter_dueDate"
            ></DateFilter>
            <FromToFilter :label-text="$t('common.outstanding.amount')"
                          columnName="outStandingAmount"
                          ref="filter_outStandingAmount"
            ></FromToFilter>
            <FromToFilter :label-text="$t('common.outstanding.percent')"
                          columnName="outStandingPercent"
                          ref="filter_outStandingPercent"
            ></FromToFilter>
        </div>
    </TableFilter>
</template>

<script>
import DateFilter from "@/components/newFilter/DateFilter";
import TextFilter from "@/components/newFilter/TextFilter";
import FromToFilter from "@/components/newFilter/FromToFilter";
import EnumFilter from "@/components/newFilter/EnumFilter";
import {enumDef} from "@/common/enumDefs";
import TableFilter from "@/components/newFilter/TableFilter";

export default {
    components: {
        TableFilter,
        EnumFilter,
        FromToFilter,
        DateFilter,
        TextFilter
    },
    data() {
        return {
            enumDef: enumDef,
        };
    },
    methods: {
        applyFilter(filters) {
            this.$emit("apply-filter", filters);
        }
    },
};
</script>